// @flow
import * as React from 'react'
import { ColoredText } from 'ui/Typography'

type Props = {
  children: React.Node,
}

export default class MutedText extends React.Component<Props> {
  render = () => {
    return <ColoredText color="gray">{this.props.children}</ColoredText>
  }
}
